"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SvgIcon = (0, vue_1.resolveComponent)("SvgIcon");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: "home-icon",
        style: (0, vue_1.normalizeStyle)({ color: 'rgba(' + _ctx.rgb + ',1)', backgroundColor: 'rgba(' + _ctx.rgb + ',0.2)' })
    }, [
        (0, vue_1.createVNode)(_component_SvgIcon, { name: _ctx.name }, null, 8, ["name"])
    ], 4));
}
exports.render = render;
